import http from '../libs/http'

export const orderCheck = (skus) => {
  return http.post({
    uri: 'mall/order/check',
    data: {skus}
  })
};

export const createOrder = (data) => {
  return http.post({
    uri: 'mall/order',
    data
  })
};

export const noPay = (bill_id) => {
  return http.get({
    uri: 'pay/noCharge',
    data: {_id: bill_id}
  })
};

export const getCart = () => {
  return http.get({
    uri: 'mall/cart/list',
  })
};

export const plusCart = (sku_id) => {
  return http.post({
    uri: 'cart/plus',
    data: {
      sku_id
    }
  });
};

export const minusCart = (sku_id) => {
  return http.post({
    uri: 'cart/minus',
    data: {
      sku_id
    }
  });
}

export const removeCart = (sku_id) => {
  return http.post({
    uri: 'cart/remove',
    data: {
      sku_infos: [sku_id]
    }
  })
}

export const selectCoupon = (coupon_id, skus = []) => {
  return http.get({
    uri: 'mall/user/order/coupon/select',
    data: {
      skus: JSON.stringify(skus),
      coupon_id,
    }
  })
};

export const getCharge = (bill_id, channel, extra) => {
  return http.get({
    url: api + 'pay/charge',
    data: {
      _id: bill_id,
      channel,
      extra
    },
  })
}

export const pollOrderSuccess = (order_id) => {
  return http.get({
    url: api + 'user/poll_order_success',
    data: {
      _id: order_id,
    }
  })
}

//根据订单返回需要评论的sku 列表
export const getCommentNeedSkuListAPI = (_id) => {
  return http.get({uri: 'user/order/comment/need/sku/list', data: {_id}});
};

export const getPaySuccessWelfareAPI = (_id) => {
  return http.get({uri: 'user/order/paySuccess/welfare', data: {_id}});
};

// 提交商品评价
export const postCommodityComment = (order_id, sku_id, spu_id, content, pics, level) => {
  return http.post({uri: 'user/commodity/comment', data: {order_id, sku_id, spu_id, content, pics, level, from: 2}});
};


// 提交订单反馈
export const postOrderFeedback = (_id, content, pics, from) => {
  return http.post({uri: 'user/order/feedback', data: {_id, content, pics, from}});
};



// WEBPACK FOOTER //
// ./src/api/order.js